export class LineupRequest {
    constructor() {
        this.ChegadaDe = new Date();
        this.ChegadaDe.setDate(this.ChegadaDe.getDate() - 7);
        this.ChegadaAte = new Date();
        this.ChegadaAte.setDate(this.ChegadaAte.getDate() + 7);
    }
}